import generateStylesheetFromCssClassesToGenerateList from '../utils/compute-new-class';

function generateStylesheetByStyleGroupClasses() {
  if (!Object.keys(window.$cssClassesToGenerate).length) {
    return;
  }

  for(let selector in window.$cssClassesToGenerate) {
    const stylesheetId = generateStyleSheetId(selector);
    const styleGroupClasses = window.$cssClassesToGenerate[selector].trim();
    generateStylesheet(stylesheetId, selector, styleGroupClasses);
  }
}

function generateStylesheet(stylesheetId, selector, styleGroupClasses) {
  const existingStyle = document.getElementById(stylesheetId);

  if (existingStyle) {
    existingStyle.parentNode.removeChild(existingStyle);
  }

  const style = document.createElement('style');
  style.id = stylesheetId;
  const css = generateStylesheetFromCssClassesToGenerateList(selector, styleGroupClasses.split(' '));

  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}

function generateStyleSheetId(inputString) {
  // Hash the input string
  const hashedString = hashString(inputString);

  // Prefix for the stylesheet ID
  const prefix = 'stylesheet';

  // Combine prefix and hashed string to create the ID
  const styleSheetId = prefix + '_' + hashedString;

  return styleSheetId;
}

// Simple hashing function
function hashString(str) {
  let hash = 0;

  if (str.length == 0) return hash;

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = Math.abs(hash); // Ensure hash is positive
  }
  return hash;
}

document.addEventListener("DOMContentLoaded", () => {
  generateStylesheetByStyleGroupClasses();
});

document.addEventListener('jb.section.rendered', () => {
  generateStylesheetByStyleGroupClasses();
});

document.addEventListener('section.initiated', () => {
  generateStylesheetByStyleGroupClasses();
});
